// @flow strict
import { Button, Card, Col, Divider, message, Modal } from "antd";
import { useState } from "react";
import { FaCheckCircle } from "react-icons/fa";
import { createSubscription, updateSubscription } from "../../api/pricing";
import { getCompId } from "../../Utility/service";
import PlanPricing from "./PlanPricing";

function PlanCard({ plan, plans, activePlan, subscription, setActivePlan }) {
  const [coupon, setCoupon] = useState(null);
  const teamId = getCompId();

  const handleClickSelect = async (e) => {
    if (!subscription?.subscriptionId) {
      handleNewSubscription();
    } else {
      const isUpgrade = activePlan.price_amount < plan.price_amount;

      Modal.confirm({
        title: isUpgrade ? 'Upgrade Subscription Plan' : 'Downgrade Subscription Plan',
        content: <p className="mb-3">{`Are you sure you want to change your subscription plan? Please note that once you make the change, you won't be able to get a refund.`}</p>,
        okText: isUpgrade ? "Upgrade Plan" : "Downgrade Plan",
        cancelText: 'Cancel',
        onOk: handleUpdateSubscription,
        okType: isUpgrade ? "primary" : "danger",
      });
    };
  };

  const handleNewSubscription = async () => {
    try {
      const res = await createSubscription({
        team_id: teamId,
        plan_id: plan?._id,
        code: coupon?.code || "",
      });

      if (res.data?.url) {
        window.open(res.data?.url, '_blank');
      }
    } catch (error) {
      message.error(error?.message);
      console.log(error)
    };
  };

  const handleUpdateSubscription = async () => {

    try {
      const res = await updateSubscription({
        subscription_id: subscription?.subscriptionId,
        plan_id: plan?._id,
        current_plan: subscription?.planId,
      });

      const priceId = res.data?.priceId;

      if (priceId) {
        const newPlan = plans.find((item) => item?.price_id === priceId);
        if (newPlan) {
          setActivePlan(newPlan);
          message.success(res.data?.message);
        };
      };
    } catch (error) {
      message.error(error?.message);
    }
  };

  const isActive = (pricePlan) => activePlan?._id === pricePlan._id;

  return (
    <Col xs={24} md={12} xl={8}>
      <Card
        hoverable
        className={(plan?.is_popular && !isActive(plan)) ? "pricing-card popular-card" : "pricing-card"}
      >
    {
      plan?.status === "inactive" && (
        <div className="coming-soon-ribbon">
          <span>Coming Soon</span>
        </div>
      )
    }

        <div className="">
          {
            isActive(plan) ? <></> : plan?.is_popular ? <p className="popular-badge">Most Popular</p> : <></>
          }
          <h3 className="pricing-title">{plan.name}</h3>
          <p className="pricing-desc">{plan.description}</p>
          <div className="pricing-items mt-2">
            <p className="pricing-item">
              <FaCheckCircle className="pricing-icon" />
              <span>{`${plan?.token} chat tokens per month.`}</span>
            </p>
            <p className="pricing-item">
              <FaCheckCircle className="pricing-icon" />
              <span>
                <span>Access to using</span>
                <span className="text-capitalize">
                  {`${plan?.chat_providers.map((provider) => " " + provider)}.`}
                </span>
              </span>
            </p>
            <p className="pricing-item">
              <FaCheckCircle className="pricing-icon" />
              <span>
                {`Max ${plan?.max_file} ${plan?.max_file > 1 ? "files" : "file"} upload per assistant.`}
              </span>
            </p>
            <p className="pricing-item">
              <FaCheckCircle className="pricing-icon" />
              <span> {`${plan?.user_count} users per organization.`}</span>
            </p>
            <p className="pricing-item">
              <FaCheckCircle className="pricing-icon" />
              <span> {`${plan?.assistant_limit} assistants per organization.`}</span>
            </p>
            <p className={plan?.advance_parameter ? "pricing-item" : "pricing-item muted"}>
              <FaCheckCircle className="pricing-icon" />
              <span> {`Access to advance parameter settings.`}</span>
            </p>
            <p className={plan?.customize_chat ? "pricing-item" : "pricing-item muted"}>
              <FaCheckCircle className="pricing-icon" />
              <span> {`Access to customize chat.`}</span>
            </p>
          </div>
        </div>

       <div className="pricing-bottom">
        <Divider />
        <PlanPricing
        plan={plan}
        coupon={coupon}
        setCoupon={setCoupon}
        subscription={subscription}
        />
      {
        plan?.status === "inactive" ? (
          <Button disabled={true} size="large" className="w-100 coming-soon-btn">
            Coming Soon
          </Button>
        ) : isActive(plan) ? (
          <Button disabled={true} size="large" className="w-100 current-plan-btn">
            Current Plan
          </Button>
        ) : (
          <Button
            type="primary"
            onClick={handleClickSelect}
            size="large"
            className={plan?.is_popular ? "w-100 popular-btn" : "w-100"}
          >
            Select Plan
          </Button>
          )
          }
       </div>
      </Card>
    </Col>

  );
};

export default PlanCard;